import React, { useEffect } from "react";
import ProjectDescription from '../components/ProjectDescription';
import { Helmet } from "react-helmet";
import { Container, Row, Col } from 'react-grid-system';
import  ProjectModel from '../models/ProjectModel';
import ProjectIndex from '../components/ProjectIndex';
import { connect } from "react-redux";
import setCoverPresent from '../redux/actions';
import '../App.css';

function BandcampExperimental({dispatch}) {
  useEffect(() => {
    dispatch(setCoverPresent('no'));
  }, []);

  return (
  <div className="wrapper">
    <div className="inner-wrapper">

	<Helmet>
	    <meta charSet="utf-8" />
	    <title>Maria Chimishkyan — {ProjectModel.BandcampExperimental.title}</title>
	</Helmet>

	    <Container fluid className="page-pad">
			<Row>
				<Col sm={3}>
					<div className="description-sticky">
					  <ProjectDescription projectModel={ProjectModel.BandcampExperimental}/>
					</div>
				</Col>
				<Col sm={6}>
					<img src="img/project-page/bandcamp-experimental/bandcamp-MariaChimishkyan-1.jpg" alt="Bandcamp Experimental — Maria Chimishkyan 1" style={{ width: '100%' }}/>
					<div style={{ marginTop: '100px' }}>
						<video className="reg" loop autoPlay style={{ width: '100%', objectFit: 'contain' }}
						src="img/project-page/bandcamp-experimental/bandcamp-MariaChimishkyan-2.mp4"
						alt="Bandcamp Experimental — Maria Chimishkyan 2"/>
					</div>
					<div style={{ marginTop: '100px' }}>
						<video className="reg" loop autoPlay style={{ width: '100%', objectFit: 'contain' }}
						src="img/project-page/bandcamp-experimental/bandcamp-MariaChimishkyan-3.mp4"
						alt="Bandcamp Experimental — Maria Chimishkyan 3"/>
					</div>
				</Col>
			</Row>
		</Container>

	</div>
	<ProjectIndex/>
</div>

  )
}

export default connect()(BandcampExperimental);
